import { Injectable } from '@angular/core';
import { Navigator } from 'src/app/services/routing/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { ConfigService } from '../config/config.service';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { JurisdictionService } from '../geo/jurisdiction.service';
import { GeoLocationStrategyService } from '../geo-location-strategy/geo-location-strategy.service';
import { GeoLocationControllerService } from '../geo-location/geo-location-controller.service';

@Injectable({
  providedIn: 'root'
})
export class LimitsService {

  public customer: CustomerModel;
  constructor(
    private userSession: UserSessionService,
    private webservice: WebservicesService,
    private configService: ConfigService,
    private geoLocationControllerService: GeoLocationControllerService,
    private geoLocationStrategyService: GeoLocationStrategyService,
    private jurisdiction: JurisdictionService,
    private navigator: Navigator
  ) {

    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );

  }

  /*
     *  GET /cashier/get-global-payment-limits
    */
  callGetGlobalPaymentLimits() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken
    }
    return this.webservice.get('cashier/get-global-payment-limits', obj);
  }

  onCloseCommon(firstLogin: boolean) {
    if (firstLogin) {
      const config = this.configService.getConfig();
      if (this.configService.isFeatureON( config, 'FEATURE_GEOLOCATION_ENFORCED_ON_LOGIN', false)) {
        if (this.geoLocationStrategyService.isGeoOptimizationEnabled()) {
          this.geoLocationControllerService.executeGeoLocationProcess()
            .then((geoResp: GeoResponse) => {
              if (geoResp.is_allowed) {
                return console.log('Signup Result geo check');
              } else {
                console.log('geo check failed');
              }
            }).catch((err) => {
              console.log("Signup Result: launch aborted.", err);
            });
        } else {
        this.jurisdiction
          .verifyJurisdiction(() => { })
          .then((geoResp: GeoResponse) => {
            console.log('Signup Result geo check');
          })
          .catch((err) => {
            console.log("Signup Result: launch aborted.", err);
          });
        }
      } else {
        this.navigator.dismissAll();
      }
    } else {
      this.navigator.dismissAll();
    }
  }
}
